export default "__VITE_ASSET__DWWWXrOt__"